import React from 'react';
import { Box } from '@mui/material';
import { brandAlt, brandAssets } from '../../brand/assets';

type BrandLogoProps = {
  variant?: 'full' | 'mark';
  height?: number | string;
};

const BrandLogo: React.FC<BrandLogoProps> = ({ variant = 'full', height = 40 }) => {
  const full = variant === 'full';
  return (
    <Box
      component="img"
      src={full ? brandAssets.logo : brandAssets.mark}
      alt={full ? brandAlt.logo : brandAlt.mark}
      sx={{
        height,
        width: 'auto',
        maxWidth: '100%',
        display: 'block',
        objectFit: 'contain',
      }}
    />
  );
};

export default BrandLogo;
